import authService from '@/api/authService';
import ErrorTitle from '@/components/errorTitle';
import { getErrorDetails, matchError } from '@/lib/errors';
import { Alert, Button, Container, type ContainerProps } from '@mantine/core';
import { IconExclamationCircle } from '@tabler/icons-react';

export interface ErrorAlertProps extends ContainerProps {
    title?: string;
    error: unknown;
    hideButton?: boolean;
}

export default function ErrorAlert({ title, error, hideButton, ...props }: ErrorAlertProps) {
    const { title: matchedTitle = 'An error occurred', message } = matchError(error, { title });
    const [appLogin] = authService.appLogin.useCache();
    const errorDetails = getErrorDetails(error, { title, user: appLogin?.user });

    return (
        <Container my="md" css={{ width: '100%' }} {...props}>
            <Alert
                color="red"
                icon={<IconExclamationCircle />}
                title={<ErrorTitle error={errorDetails}>{matchedTitle}</ErrorTitle>}
            >
                <div
                    css={{
                        margin: '10px 0',
                        maxHeight: '5em',
                        overflowY: 'auto',
                        whiteSpace: 'pre-wrap',
                    }}
                >
                    {message}
                </div>

                {!hideButton && (
                    <Button onClick={() => window.location.reload()}>Reload Page</Button>
                )}
            </Alert>
        </Container>
    );
}
